import { render, staticRenderFns } from "./topbar.vue?vue&type=template&id=9c1a7406&scoped=true&"
import script from "./topbar.vue?vue&type=script&lang=js&"
export * from "./topbar.vue?vue&type=script&lang=js&"
import style0 from "./topbar.vue?vue&type=style&index=0&id=9c1a7406&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c1a7406",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9c1a7406')) {
      api.createRecord('9c1a7406', component.options)
    } else {
      api.reload('9c1a7406', component.options)
    }
    module.hot.accept("./topbar.vue?vue&type=template&id=9c1a7406&scoped=true&", function () {
      api.rerender('9c1a7406', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/navegacao-v2/components/topbar.vue"
export default component.exports